// extracted by mini-css-extract-plugin
export default {"navBar":"styles_navBar__1uh2+","logo":"styles_logo__2z3BT"};